import { App, Button, Popconfirm, Popover, Space } from 'antd';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { deleteItems, getServices } from '../../network/Item';

const ServicesPage = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getServices],
    queryFn: () => getServices(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteItems(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success('Record successfully deleted!');
        //  message.success('تم الحذف بنجاح');
        client.invalidateQueries({ queryKey: [queryKeys.getItems] });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: t.itemName,
      dataIndex: 'item_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.item_name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/service/${record.name}`)
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.type,
      dataIndex: 'item_group',
    },
    // {
    //   title: t.shelfLifeInDays,
    //   dataIndex: 'shelf_life_in_days',
    // },
    {
      title: t.price,
      dataIndex: 'rate',
    },
    {
      title: t.unitofMeasure,
      dataIndex: 'stock_uom',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space>
            <Popover placement="top" title={t.edit}>
              <Button
                size="small"
                type="primary"
                onClick={() => navigate(`/service/${record.name}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.Deletetheservice}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.message?.items?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      <Heading title={t.Healthcare} subTitle={t.services} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.AddService}
        Placeholder={t.searchItems}
        pathBtn="/service/add"
      />
    </div>
  );
};

export default ServicesPage;
